export default {
  rankOrder: {
    ariaAddOption: 'Voeg {label} by die gerangschikte lys',
    ariaMoveUp: 'Skuif {label} op',
    ariaMoveDown: 'Skuif {label} af',
    ariaRemoveOption: 'Verwyder {label} van die gerangschikte lys',
  },
  coe: {
    ariaDisclaimer: 'Kennisgewing',
    ariaQuestion: 'Vraag',
    ariaConversationHistory: 'Gespreksgeskiedenis',
    ariaYourResponse: 'Jou antwoord {number}',
    ariaFollowUpQuestion: 'Opvolgvraag {number}',
    ariaResponseInput: 'Antwoordveld',
    ariaRespondingTo: 'Antwoord op',
    ariaSendResponse: 'Stuur antwoord',
    ariaThinking: 'Dink'
  },
  deviceView: {
    toolbar: 'Voorskou-toestel',
    mobile: 'Selfoon',
    tablet: 'Tablet',
    desktop: 'Rekenaar'
  },
  header: {
    customLogoAlt: 'Logo',
    defaultLogoAlt: 'QuestDIY-logo'
  }
}
